export function handleNumericInput(event) {
    event.target.value = event.target.value.replace(/\D/g, '');
}

export function validacpf(cpf) {
  cpf = cpf.replace(/[^\d]+/g,''); // Remove qualquer coisa que não seja número
  if (cpf.length !== 11) return false;

  let soma = 0;
  let resto;

  // Verifica se todos os dígitos são iguais, o que invalida o CPF
  if (/^(\d)\1+$/.test(cpf)) return false;

  // Calcula o primeiro dígito verificador
  for (let i = 1; i <= 9; i++) {
      soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }
  resto = (soma * 10) % 11;

  if ((resto === 10) || (resto === 11)) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;

  // Calcula o segundo dígito verificador
  soma = 0;
  for (let i = 1; i <= 10; i++) {
      soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }
  resto = (soma * 10) % 11;

  if ((resto === 10) || (resto === 11)) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;

  return true;
}

export function validacnpj(cnpj) {
  cnpj = cnpj.replace(/[.\-\/]/g, '').toUpperCase();

  // 12 primeiros caracteres alfanuméricos + 2 dígitos verificadores numéricos
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;

  // Evita sequências com todos os caracteres iguais
  if (/^(.)\1+$/.test(cnpj)) return false;

  const base = cnpj.substring(0, 12);
  const dvInformado1 = parseInt(cnpj.charAt(12), 10);
  const dvInformado2 = parseInt(cnpj.charAt(13), 10);

  const pesosDv1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesosDv2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  // Regra 1: Conversão ASCII - 48 para os 12 primeiros caracteres
  function charToValue(char) {
    return char.charCodeAt(0) - 48;
  }

  // Regra 3: Se resto 0 ou 1 -> DV 0; se 2..10 -> 11 - resto
  function calcularDv(soma) {
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  }

  // Regra 2: Cálculo do 1º DV com pesos [5..2,9..2]
  let soma1 = 0;
  for (let i = 0; i < 12; i++) {
    soma1 += charToValue(base.charAt(i)) * pesosDv1[i];
  }
  const dvCalculado1 = calcularDv(soma1);
  if (dvCalculado1 !== dvInformado1) return false;

  // Regra 2: Cálculo do 2º DV com pesos [6..2,9..2], incluindo o 1º DV
  const baseComDv1 = `${base}${dvCalculado1}`;
  let soma2 = 0;
  for (let i = 0; i < 13; i++) {
    soma2 += charToValue(baseComDv1.charAt(i)) * pesosDv2[i];
  }
  const dvCalculado2 = calcularDv(soma2);
  if (dvCalculado2 !== dvInformado2) return false;

  return true;
}
